<template>
  <div>
    <DataSearch :searchData="searchData" @show-charts="showCharts" v-show="!showEchart" />
    <div class="dataview-container" ref="dataviewContainer" v-show="showEchart">
      <!-- 顶部搜索区域 -->
      <div class="top-section">
        <h1 class="title">华艺数资查询</h1>
        <div class="search-box">
          <input type="text" placeholder="请输入商品发行ID/交易哈希进行搜索" v-model="searchQuery" />
          <search @click="handleSearch" class="search-icon" theme="outline" size="20" fill="#8c9198" />
        </div>
      </div>

      <!-- 图表区域 -->
      <div class="chart-container">

        <!-- 数据卡片区域 -->
        <div class="cards-container">
          <div class="data-card">
            <div class="card-number">{{ displayNumbers.totalWorks }}</div>
            <div class="card-label">华艺链作品总数</div>
          </div>
          <div class="data-card">
            <div class="card-number">{{ displayNumbers.totalAssets }}</div>
            <div class="card-label">数字资产总数</div>
          </div>
          <div class="data-card">
            <div class="card-number">{{ displayNumbers.totalAccounts }}</div>
            <div class="card-label">账户总数</div>
          </div>
        </div>

        <div class="chart-header">
          <!-- 将文本拆分为可点击的标签 -->
          <span class="chart-tag" :class="{ active: currentTag === 'works' }" @click="switchTag('works')">链上作品总数</span>
          <span class="chart-tag-separator">/</span>
          <span class="chart-tag" :class="{ active: currentTag === 'assets' }"
            @click="switchTag('assets')">数字资产总数</span>
          <span class="chart-tag-separator">/</span>
          <span class="chart-tag" :class="{ active: currentTag === 'accounts' }"
            @click="switchTag('accounts')">账户总数</span>
        </div>
        <div class="chart-wrapper">
          <!-- Y轴刻度 - 使用固定定位确保与网格线对齐 -->
          <div class="y-axis">
  <div class="y-tick" style="top: 0;">15000</div>
  <div class="y-tick" style="top: 60px;">12000</div>
  <div class="y-tick" style="top: 120px;">9000</div>
  <div class="y-tick" style="top: 180px;">6000</div>
  <div class="y-tick" style="top: 240px;">3000</div>
  <div class="y-tick" style="top: 300px;">0</div>
</div>
          <!-- 图表主体 -->
          <div class="chart-main">
            <!-- 折线图 -->
            <svg class="line-chart" viewBox="0 0 1000 300" preserveAspectRatio="none" @mousemove="handleMouseMove"
              @mouseleave="handleMouseLeave">
              <!-- Y轴横线标识 - 与Y轴刻度精确定位 -->
              <g class="grid-lines">
                <line x1="0" y1="0" x2="1000" y2="0" /> <!-- 50 -->
                <line x1="0" y1="60" x2="1000" y2="60" /> <!-- 40 -->
                <line x1="0" y1="120" x2="1000" y2="120" /> <!-- 30 -->
                <line x1="0" y1="180" x2="1000" y2="180" /> <!-- 20 -->
                <line x1="0" y1="240" x2="1000" y2="240" /> <!-- 10 -->
                <line x1="0" y1="300" x2="1000" y2="300" /> <!-- 0 -->
              </g>
              <!-- 折线图路径 -->
              <path class="line" :d="currentChartData.path" />
              <!-- 填充区域 -->
              <path class="fill" :d="currentChartData.fillPath" />
              <!-- 鼠标移动时的标记点 -->
              <g v-if="showTooltip" class="tooltip-group">
                <!-- 垂直参考线 -->
                <line class="tooltip-line" :x1="tooltipPosition.x" :y1="0" :x2="tooltipPosition.x" :y2="300" />
                <!-- 数据点标记 - 使用圆形背景和白色边框 -->
                <circle class="tooltip-point" :cx="tooltipPosition.x" :cy="tooltipPosition.y" r="5" />
                <!-- 背景模糊半透明的小tag显示数据 -->
                <g>
                  <!-- 白色背景 -->
                  <rect class="tooltip-background"
                    :x="tooltipPosition.x < 950 ? tooltipPosition.x + 15 : tooltipPosition.x - 85"
                    :y="tooltipPosition.y - 50" width="70" height="40" rx="4" ry="4" />
                  <!-- 时间文本 -->
                  <text class="tooltip-date-text"
                    :x="tooltipPosition.x < 950 ? tooltipPosition.x + 50 : tooltipPosition.x - 50"
                    :y="tooltipPosition.y - 40" text-anchor="middle" dominant-baseline="middle">
                    {{ currentTooltipDate }}
                  </text>
                  <!-- 数据文本 -->
                  <text class="tooltip-count-text"
                    :x="tooltipPosition.x < 950 ? tooltipPosition.x + 50 : tooltipPosition.x - 50"
                    :y="tooltipPosition.y - 20" text-anchor="middle" dominant-baseline="middle">
                    {{ currentTooltipValue }}个
                  </text>
                </g>
              </g>
            </svg>
            <!-- X轴刻度 -->
            <div class="x-axis">
              <div class="x-tick" v-for="(tick, index) in xAxisTicks" :key="index"
                :style="{ left: `${(index / (xAxisTicks.length - 1)) * 100}%` }">
                {{ tick }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 自定义居中弹窗 -->
    <div class="custom-alert-overlay" v-if="showAlert">
      <div class="custom-alert">
        <div class="alert-content">{{ alertMessage }}</div>
      </div>
    </div>
  </div>

</template>

<script>
// 检查API文件的导出方式，如果是命名导出则使用解构导入
import getEcharts from '@/api/getEcharts.js'
import getCertificate from '@/api/getCertificate.js'
import { Search } from '@icon-park/vue'
import DataSearch from '@/views/DataSearch.vue'
export default {
  name: 'Dataview',
  components: {
    Search,
    DataSearch
  },
  data () {
    return {
      showEchart: true,
      searchQuery: '', // 添加搜索查询数据
      searchData: null, // 添加搜索结果数据
      displayNumbers: {
        totalWorks: 0,
        totalAssets: 0,
        totalAccounts: 0
      },
      actualNumbers: {
        totalWorks: 0,
        totalAssets: 0,
        totalAccounts: 0
      },
      currentTag: 'works',
      xAxisTicks: [],
      chartData: {
        works: { path: '', fillPath: '' },
        assets: { path: '', fillPath: '' },
        accounts: { path: '', fillPath: '' }
      },
      chartPoints: {
        works: [],
        assets: [],
        accounts: []
      },
      showTooltip: false,
      tooltipPosition: { x: 0, y: 0 },
      currentTooltipValue: 0, // 当前显示的tooltip数据
      currentTooltipDate: '',  // 当前显示的tooltip日期
      observer: null, // Intersection Observer实例
      showAlert: false, // 控制弹窗显示
      alertMessage: '' // 弹窗消息
    }
  },
  computed: {
    currentChartData () {
      return this.chartData[this.currentTag] || { path: '', fillPath: '' }
    }
  },
  mounted () {
    this.fetchEchartsData() // 获取所有数据
    this.initIntersectionObserver() // 初始化Intersection Observer
  },
  methods: {
    async handleSearch () {
      try {
        // 验证搜索查询是否存在
        if (!this.searchQuery.trim()) {
          console.error('请输入搜索内容')
          // 使用自定义弹窗替换原来的alert
          this.showCustomAlert('搜索内容不能为空')
          return
        }

        // 调用API获取数据，传递asset_id参数
        const response = await getCertificate(this.searchQuery.trim())
        console.log('搜索结果', response);
        // 验证搜索结果是否为空
        if (!response || response.length === 0) {
          console.error('搜索结果为空')
          // 使用自定义弹窗替换原来的alert
          this.showCustomAlert('搜索结果为空')
          return
        }

        this.searchData = response // 保存搜索结果
        this.showEchart = false // 切换到搜索结果页面
      } catch (error) {
        console.error('搜索请求失败:', error)
      }
    },
    // 新增方法：响应来自子组件的事件，显示图表
    showCharts () {
      this.showEchart = true;
    },
    // 初始化Intersection Observer
    initIntersectionObserver () {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 当元素进入视窗时，开始数字动画
            this.startNumberAnimation()
            // 取消观察，避免重复触发
            this.observer.unobserve(this.$refs.dataviewContainer)
          }
        })
      }, {
        threshold: 0.1 // 当元素10%可见时触发
      })

      // 开始观察dataviewContainer元素
      if (this.$refs.dataviewContainer) {
        this.observer.observe(this.$refs.dataviewContainer)
      }
    },

    // 开始数字动画
    startNumberAnimation () {
      // 重置显示数字为0
      this.displayNumbers.totalWorks = 0
      this.displayNumbers.totalAssets = 0
      this.displayNumbers.totalAccounts = 0

      // 设置动画参数
      const duration = 2000 // 动画持续时间2秒
      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1) // 确保进度不超过1

        // 使用缓动函数使动画更平滑
        const easeProgress = this.easeOutCubic(progress)

        // 更新显示数字
        this.displayNumbers.totalWorks = Math.floor(easeProgress * this.actualNumbers.totalWorks)
        this.displayNumbers.totalAssets = Math.floor(easeProgress * this.actualNumbers.totalAssets)
        this.displayNumbers.totalAccounts = Math.floor(easeProgress * this.actualNumbers.totalAccounts)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          // 动画完成，确保显示最终数值
          this.displayNumbers.totalWorks = this.formatNumber(this.actualNumbers.totalWorks)
          this.displayNumbers.totalAssets = this.formatNumber(this.actualNumbers.totalAssets)
          this.displayNumbers.totalAccounts = this.formatNumber(this.actualNumbers.totalAccounts)
        }
      }

      requestAnimationFrame(animate)
    },

    // 缓动函数 - 三次方缓出
    easeOutCubic (t) {
      return 1 - Math.pow(1 - t, 3)
    },

    // 获取Echarts数据 - 适配不同的导出方式
    async fetchEchartsData () {
      try {
        console.log('正在请求Echarts数据...')

        // 调用API获取数据，根据实际导出的函数名调整
        const response = await getEcharts()
        console.log(response)

        // 更新实际数字
        const data = response || {}
        this.actualNumbers = {
          totalWorks: data.articlesTotal || 0,
          totalAssets: data.articlesQukTotal || 0,
          totalAccounts: data.userTotal || 0
        }

        // 不立即更新显示数字，等待页面进入视窗后再动画
        // this.displayNumbers.totalWorks = this.formatNumber(this.actualNumbers.totalWorks)
        // this.displayNumbers.totalAssets = this.formatNumber(this.actualNumbers.totalAssets)
        // this.displayNumbers.totalAccounts = this.formatNumber(this.actualNumbers.totalAccounts)

        // 处理图表数据
        this.processChartData('works', data.pczhexian || [])
        this.processChartData('assets', data.pcShuzizhexian || [])
        this.processChartData('accounts', data.pcUserzhexian || [])

        console.log('成功获取Echarts数据')
      } catch (error) {
        console.error('获取Echarts数据失败:', error)
        // 使用默认值
        this.actualNumbers = {
          totalWorks: 0,
          totalAssets: 0,
          totalAccounts: 0
        }

        // 不立即更新显示数字
        // this.displayNumbers.totalWorks = this.formatNumber(this.actualNumbers.totalWorks)
        // this.displayNumbers.totalAssets = this.formatNumber(this.actualNumbers.totalAssets)
        // this.displayNumbers.totalAccounts = this.formatNumber(this.actualNumbers.totalAccounts)

        // 使用空数据
        this.processChartData('works', [])
        this.processChartData('assets', [])
        this.processChartData('accounts', [])
      }
    },

    formatNumber (num) {
      // 格式化数字为带逗号的形式
      return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 切换标签 - 无需重新请求数据，直接切换显示
    switchTag (tag) {
      this.currentTag = tag
    },
    // 处理图表数据 - 更新计算逻辑确保数据点位置正确
    processChartData (tag, realData) {
      const points = []
      const totalWidth = 1000
      const pointCount = realData.length || 30
      const maxValue = 15000 // 最大值为50
      const chartHeight = 300 // 图表高度增加到300px

      // 生成x轴刻度，使用API返回的实际日期
      const ticks = []
      for (let i = 0; i < pointCount; i++) {
        const dataPoint = realData[i] || { date: '', count: 0 }
        // 从API返回的日期中提取月份和日期，例如 "2025-12-08" -> "12-08"
        if (dataPoint.date) {
          const dateParts = dataPoint.date.split('-')
          if (dateParts.length >= 3) {
            ticks.push(`${dateParts[1]}-${dateParts[2]}`)
          } else {
            ticks.push('')
          }
        } else {
          ticks.push('')
        }
      }
      this.xAxisTicks = ticks

      // 从真实数据生成点
      for (let i = 0; i < pointCount; i++) {
        const dataPoint = realData[i] || { date: '', count: 0 }

        // 计算X位置（均匀分布在1000个单位上）
        const x = (i / (pointCount - 1)) * totalWidth

        // 计算Y位置（从0到50缩放以适应图表高度）
        // 0对应y=300，50对应y=0
        const yScale = chartHeight / maxValue
        const y = chartHeight - (parseInt(dataPoint.count) * yScale)

        points.push({
          x,
          y: Math.max(0, Math.min(chartHeight, y)), // 确保在边界内
          value: parseInt(dataPoint.count),
          date: dataPoint.date
        })
      }

      // 构建折线图路径
      let path = pointCount > 0 ? `M${points[0].x},${points[0].y}` : ''

      // 使用直线连接所有点
      for (let i = 1; i < points.length; i++) {
        path += ` L${points[i].x},${points[i].y}`
      }

      // 构建填充区域路径
      const fillPath = pointCount > 0 ? path + ` L${totalWidth},${chartHeight} L0,${chartHeight} Z` : ''

      // 更新图表数据
      this.chartData[tag] = {
        path,
        fillPath
      }

      // 保存数据点用于鼠标悬停交互
      this.chartPoints[tag] = points
    },
    // 处理鼠标移动事件
    handleMouseMove (event) {
      const svg = event.currentTarget
      const rect = svg.getBoundingClientRect()
      const x = event.clientX - rect.left

      // 将鼠标位置映射到SVG坐标系
      const svgX = (x / rect.width) * 1000

      // 找到最接近的X轴刻度位置
      const points = this.chartPoints[this.currentTag] || []

      if (points.length === 0) return

      // 计算最接近的点
      let closestIndex = 0
      let minDistance = Math.abs(points[0].x - svgX)

      for (let i = 1; i < points.length; i++) {
        const distance = Math.abs(points[i].x - svgX)
        if (distance < minDistance) {
          minDistance = distance
          closestIndex = i
        }
      }

      // 设置工具提示位置和当前显示的值
      this.tooltipPosition = {
        x: points[closestIndex].x,
        y: points[closestIndex].y
      }
      this.currentTooltipValue = points[closestIndex].value

      // 格式化日期
      if (points[closestIndex].date) {
        const date = new Date(points[closestIndex].date)
        this.currentTooltipDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`
      } else {
        // 如果没有日期，使用当前索引对应的日期
        const today = new Date()
        const date = new Date(today)
        date.setDate(today.getDate() - (29 - closestIndex))
        this.currentTooltipDate = `/${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`
      }

      // 显示工具提示
      this.showTooltip = true
    },
    // 处理鼠标离开事件
    handleMouseLeave () {
      // 隐藏工具提示
      this.showTooltip = false
    },

    // 组件销毁前清理Observer
    beforeDestroy () {
      if (this.observer) {
        this.observer.disconnect()
      }
    },

    // 显示自定义弹窗的方法
    showCustomAlert(message) {
      this.alertMessage = message
      this.showAlert = true
      // 2秒后自动隐藏
      setTimeout(() => {
        this.showAlert = false
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.dataview-container {
  width: 100%;
  min-height: 100vh;
  background: #FAFAFA;
  padding: 20px;
  padding-top: 80px;
  box-sizing: border-box;
}

.top-section {
  height: 130px;
  background-image: url('https://hyyjs.oss-cn-beijing.aliyuncs.com/miniApp/%E5%8D%8E%E8%89%BA%E9%93%BE_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%208.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 30px;
  text-align: center;
  margin-bottom: 20px;
  max-width: 1900px;

  .title {
    font-size: 24px;
    color: white;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .search-box {
    position: relative;
    max-width: 500px;
    margin: 0 auto;

    input {
      width: 100%;
      height: 40px;
      border: none;
      border-radius: 25px;
      font-size: 16px;
      outline: none;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.9);
      transition: all 0.3s ease;

      &:focus {
        box-shadow: 0 0 0 2px rgba(255, 122, 69, 0.3);
      }
    }

    .search-icon {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 100px; // 设置高度
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0 25px 25px 0; // 圆角
      background-color: white; // 背景颜色
      cursor: pointer;
      transition: all 0.3s ease;
      z-index: 1;

      &:hover {
        background-color: #eeeeee;
      }
    }
  }
}

.cards-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .data-card {
    flex: 1;
    background: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    margin: 0 10px;
    border-right: 1px solid #eee;

    &:last-child {
      border-right: none;
    }

    .card-number {
      font-size: 32px;
      font-weight: bold;
      color: #ff7a45;
      margin-bottom: 10px;
      transition: none;
      /* 禁用可能的过渡效果，让动画更流畅 */
    }

    .card-label {
      font-size: 18px;
      font-weight: bold;
      color: #000;
    }
  }
}

.chart-container {
  background: white;
  padding: 20px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  max-width: 1900px;
  /* 适合1920x1080显示器的最大宽度 */
  margin: 0 auto;
  /* 居中显示 */
  box-sizing: border-box;

  .chart-header {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .chart-tag {
      cursor: pointer;
      padding: 5px 10px;
      font-size: 14px;
      color: #666;
      transition: all 0.3s;

      &:hover {
        color: #ff7a45;
      }

      &.active {
        color: #ff7a45;
        font-weight: bold;
      }
    }

    .chart-tag-separator {
      margin: 0 10px;
      color: #ddd;
    }
  }

  .chart-wrapper {
    display: flex;
    width: 100%;
    height: 355px;
    /* 固定高度，图表300px + X轴55px */
    position: relative;

    .y-axis {
      width: 50px;
      text-align: right;
      padding-right: 10px;
      height: 300px;
      /* 与图表高度一致 */
      position: relative;

      .y-tick {
        font-size: 12px;
        color: #999;
        position: absolute;
        right: 0;
        transform: translateY(-50%);
        /* 垂直居中对齐刻度 */
      }
    }

    .chart-main {
      flex: 1;
      position: relative;

      .line-chart {
        width: 100%;
        height: 300px;
        /* 图表高度 */
        cursor: pointer;
        /* 显示指针光标 */
        display: block;

        // Y轴横线样式
        .grid-lines {
          line {
            stroke: #eee;
            stroke-width: 1;
            stroke-dasharray: none;
          }
        }

        .line {
          fill: none;
          stroke: #ff7a45;
          stroke-width: 2;
          transition: d 0.5s ease-in-out;
        }

        .fill {
          fill: rgba(255, 122, 69, 0.3);
          transition: d 0.5s ease-in-out;
        }

        // 鼠标移动时的标记线样式
        .tooltip-line {
          stroke: #ff7a45;
          stroke-width: 1;
          stroke-dasharray: 5, 5;
          opacity: 0.7;
        }

        // 鼠标移动时的数据点标记样式 - 添加transform防止拉伸
        .tooltip-group {
          transform-origin: center;

          .tooltip-point {
            fill: #ff7a45;
            stroke: white;
            stroke-width: 2;
            opacity: 1;
          }

          // 白色背景带阴影
          .tooltip-background {
            fill: white; // 白色背景
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, .2)); // 添加阴影效果
            min-width: 30px; // 最小宽度
            max-width: 100%; // 最大宽度
          }

          // 日期文本
          .tooltip-date-text {
            fill: #999;
            font-size: 11px;
            font-weight: normal;
            pointer-events: none; // 文本不可点击，不影响交互
          }

          // 数据文本
          .tooltip-count-text {
            fill: #ff7a45;
            font-size: 13px;
            font-weight: bold;
            pointer-events: none; // 文本不可点击，不影响交互
          }
        }
      }

      .x-axis {
        position: relative;
        height: 55px;
        /* 增加X轴高度，确保日期显示清晰 */
        margin-top: 15px;
        /* 在SVG和X轴之间添加间距 */

        .x-tick {
          position: absolute;
          transform: translateX(-50%);
          text-align: center;
          font-size: 11px;
          color: #999;
          width: 50px;
          /* 固定宽度确保文本居中 */
          margin-top: 5px;
          /* 距离X轴线的距离 */
        }
      }
    }
  }
}

/* 自定义弹窗样式 */
.custom-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-alert {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.3s ease;
}

.alert-content {
  font-size: 16px;
  color: #333;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>